import isFuture from 'date-fns/is_future';
import useCountdown from 'Jsx/Shared/Hooks/useCountdown';

const getPromoRemainingTime = (days, hours): string | null => {
  if (days > 0) {
    return `${days} ${days > 1 ? 'dias' : 'dia'}`;
  }

  if (hours > 0) {
    return `${hours} ${hours > 1 ? 'horas' : 'hora'}`;
  }

  return null;
};

const useCoursePromoCountdown = dueDate => {
  const { rawDays, hours } = useCountdown(new Date(dueDate));

  const promoRemainingTime = isFuture(new Date(dueDate))
    ? getPromoRemainingTime(rawDays, hours)
    : null;

  return { promoRemainingTime };
};

export default useCoursePromoCountdown;
